<template>
  <div class="container-fluid px-0 mt-4">
    <div class="row">
      <div class="col-12 mb-4">
        <div
          :class="`text-${getColorMode.text} border-${getColorMode.globalBackground} p-1 border-radius-20`"
        >
          <h1>Home</h1>
          <select
            class="form-select w-25"
            v-model="selectedProject"
            @change="setData"
          >
            <option selected :value="null">Todos</option>
            <option
              v-for="(project, key) in projectList"
              :key="`project${key}`"
              :value="project"
            >
              {{ project.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="row h-100">
            <div
              class="col-6"
              v-for="(card, k) in cards.filter(
                (card) => card.role === 'primary'
              )"
              v-bind:key="`cardKey${k}`"
            >
              <Popper
                v-if="card.role === 'primary'"
                class="w-100 m-0 border-0 home-cards"
                :content="card.text"
                placement="top"
                hover
                arrow
              >
                <div
                  :class="`border-0`"
                  :style="{ backgroundColor: 'inherit' }"
                >
                  <div class="row g-0">
                    <div
                      class="col-4 d-flex"
                      :style="{ backgroundColor: card.color }"
                    >
                      <div class="h1 d-flex align-self-center mx-auto">
                        <font-awesome-icon
                          :icon="['fas', card.icon]"
                          size="lg"
                          class="icon-report-card text-white"
                        />
                      </div>
                    </div>
                    <div class="col-8" :style="{ backgroundColor: card.color }">
                      <div class="card-body text-left">
                        <p
                          class="card-text text-white home-card-title mb-0 line-height-100"
                        >
                          {{ card.value }}
                        </p>
                        <h5 class="card-title home-card-subtitle text-white">
                          {{ card.title }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Popper>
            </div>
            <div
              class="col-3 d-flex align-items-end justify-content-end"
              v-for="(card, k) in cards.filter(
                (card) => card.role === 'secondary'
              )"
              v-bind:key="`cardKey${k}`"
            >
              <Popper
                class="w-100 m-0 border-0 home-secondary-cards"
                :style="{ height: '100%' }"
                :content="card.text"
                placement="top"
                hover
                arrow
              >
                <div :class="`card mb-2 border-${getColorMode.background}`">
                  <div class="row g-0">
                    <div
                      class="col-12 d-flex"
                      :style="{ backgroundColor: '#00708C6B' }"
                    >
                      <div
                        class="d-flex align-items-center justify-content-center w-100"
                        :style="{ height: '100%' }"
                      >
                        <p
                          class="home-card-secondary-subtitle card-text text-white mb-0 line-height-100 p-1"
                        >
                          {{ card.value }}
                        </p>
                        <p class="home-card-secondary-title text-white mb-0">
                          {{ card.title }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Popper>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div
            :class="`chart-div my-auto bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} p-4 position-relative h-100 border-radius-20`"
          >
            <Loading v-if="!fileFolders" text="" />
            <div class="row">
              <div class="col-6">
                <div class="h3">Archivos</div>
              </div>
              <div class="col-6">
                <select class="form-select" v-model="selectedChart">
                  <option
                    v-for="(chart, key) in charts"
                    :key="`chart${key}`"
                    :value="chart.value"
                  >
                    {{ chart.title }}
                  </option>
                </select>
              </div>
            </div>
            <DoughnutChart
              v-if="selectedChart === 'fileFolders' && fileFolders"
              :chartData="fileFolders"
              :options="options"
            />
            <DoughnutChart
              v-if="selectedChart === 'fileUsers' && fileUsers"
              :chartData="fileUsers"
              :options="options"
            />
            <DoughnutChart
              v-if="selectedChart === 'fileCompanies' && fileCompanies"
              :chartData="fileCompanies"
              :options="options"
            />
          </div>
        </div>
      </div>
      <!-- <div class="col-4 mb-4 mt-5">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table p-3 position-relative`"
        >
          <Loading v-if="!fileFolders" text="" />
          <div class="h3">Archivos por carpetas</div>
          <DoughnutChart :chartData="fileFolders" v-if="fileFolders" />
        </div>
      </div>
      <div class="col-4 mb-4 mt-5">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table p-3 position-relative`"
        >
          <Loading v-if="!fileUsers" text="" />
          <div class="h3">Archivos por usuarios</div>
          <DoughnutChart :chartData="fileUsers" v-if="fileUsers" />
        </div>
      </div>
      <div class="col-4 mb-4 mt-5">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table p-3 position-relative`"
        >
          <Loading v-if="!fileCompanies" text="" />
          <div class="h3">Archivos por empresas</div>
          <DoughnutChart :chartData="fileCompanies" v-if="fileCompanies" />
        </div>
      </div> -->
      <div class="col-12 my-4">
        <div
          :class="`p-4 border-radius-20 bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} p-3 position-relative`"
        >
          <Loading v-if="!lastFiles" text="" />
          <div class="h3">Últimos archivos subidos</div>
          <table
            :class="`table table-${getColorMode.background} table-condensed small mt-4`"
          >
            <thead>
              <tr>
                <td>Tipo</td>
                <td>Nombre</td>
                <td>Proyecto</td>
                <td>Ubicación</td>
                <td>Fecha de carga</td>
                <td>Cargado por</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(file, key) in lastFiles" :key="`lastFiles${key}`">
                <td>
                  <font-awesome-icon
                    :icon="['fal', setIcon(file)]"
                    :class="setIconColor(file)"
                    size="lg"
                  />
                </td>
                <td>
                  {{
                    file.name.length > 18
                      ? `${file.name.substring(0, 10)}...${file.extension}`
                      : file.name
                  }}
                </td>
                <td>
                  {{ file.project.name }}
                </td>
                <td>
                  {{ file.complete_path }}
                </td>
                <td>
                  {{ $dayjs(file.created_at).format("DD-MM-YYYY HH:mm") }}
                </td>
                <td>
                  {{ file.user.name }}
                </td>
                <td>
                  <Popper
                    class="btn btn-primary m-0 border-0"
                    content="Ver"
                    placement="top"
                    hover
                    arrow
                    @click="setModal(file)"
                  >
                    <font-awesome-icon :icon="['fas', 'eye']" />
                  </Popper>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <FileViewer
      @close-modal="modalFileViewer = false"
      :projectId="selectedFile.project_id"
      :fileId="selectedFile.id"
      :folderId="selectedFile.folder_id"
      :showDetails="true"
      v-if="modalFileViewer"
    />
  </div>
</template>
<script>
import { DoughnutChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import { mapGetters } from "vuex";
import Loading from "@/components/Loading.vue";
import FileViewer from "@/components/FileViewer.vue";
Chart.register(...registerables);
export default {
  name: "report-index",
  emits: ["setBreadcrumb"],
  components: { DoughnutChart, Loading, FileViewer },
  data() {
    return {
      breadcrumb: [{ text: "Reportes", link: { name: "reports" } }],
      lastFiles: null,
      fileFolders: null,
      fileUsers: null,
      fileCompanies: null,
      selectedProject: null,
      projectList: null,
      modalFileViewer: false,
      selectedFile: null,
      selectedChart: "fileFolders",
      charts: [
        { title: "Archivos por carpetas", value: "fileFolders" },
        { title: "Archivos por usuario", value: "fileUsers" },
        { title: "Archivos por empresas", value: "fileCompanies" },
      ],
      cards: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: 25,
        },
        plugins: {
          legend: {
            position: "right",
          },
        },
      },
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
    this.setProjects();
  },
  methods: {
    setProjects() {
      let app = this;
      this.axios
        .get(`projects`)
        .then((result) => {
          app.projectList = result.data.body.data;
          // app.selectedProject = app.projectList[0]; to set home report to first project
          this.setData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setData() {
      let app = this;
      app.lastFiles = null;
      app.fileFolders = null;
      app.fileUsers = null;
      app.fileCompanies = null;
      let labelFolders = [];
      let labelUsers = [];
      let labelCompanies = [];
      let colors = [
        "#263F73",
        "#FF671D",
        "#29B9F2",
        "#F2CB05",
        "#F28705",
        "#7F63A6",
        "#D9115A",
        "#3C3D59",
        "#367334",
      ];
      let dataFolders = [];
      let dataUsers = [];
      let dataCompanies = [];
      let Projectid = app.selectedProject
        ? app.selectedProject.id
        : app.projectList
        ? `${app.projectList[0].id}`
        : "";
      this.axios
        .get(`reports?project_id=${Projectid}`)
        .then((result) => {
          app.lastFiles = result.data.body.last_files;
          app.cards = result.data.body.cards;
          result.data.body.file_folders.map((folder) => {
            //colors.push(this.checkColor("#"+Math.floor(Math.random()*16777215).toString(16), colors))
            labelFolders.push(`${folder.name} (${folder.files_q})`);
            dataFolders.push(folder.files_q);
          });
          result.data.body.file_users.map((folder) => {
            //colors.push(this.checkColor("#"+Math.floor(Math.random()*16777215).toString(16), colors))
            labelUsers.push(`${folder.name} (${folder.files_q})`);
            dataUsers.push(folder.files_q);
          });
          result.data.body.file_companies.map((folder) => {
            //colors.push(this.checkColor("#"+Math.floor(Math.random()*16777215).toString(16), colors))
            labelCompanies.push(`${folder.name} (${folder.files_q})`);
            dataCompanies.push(folder.files_q);
          });
          app.fileFolders = {
            labels: labelFolders,
            datasets: [
              {
                data: dataFolders,
                backgroundColor: colors,
                borderColor: colors,
              },
            ],
          };
          app.fileUsers = {
            labels: labelUsers,
            datasets: [
              {
                data: dataUsers,
                backgroundColor: colors,
                borderColor: colors,
              },
            ],
          };
          app.fileCompanies = {
            labels: labelCompanies,
            datasets: [
              {
                data: dataCompanies,
                backgroundColor: colors,
                borderColor: colors,
              },
            ],
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setModal(item) {
      this.selectedFile = item;
      this.modalFileViewer = true;
    },
    checkColor(color, colors) {
      let selColor = colors.includes(color)
        ? this.checkColor(
            "#" + Math.floor(Math.random() * 16777215).toString(16),
            colors
          )
        : color;
      return selColor;
    },
    setIcon(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "file-image";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "file-word";
      } else if (["xml"].includes(item.extension)) {
        return "file-spreadsheet";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "file-pdf";
      } else {
        return "file";
      }
    },
    setIconColor(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "text-secondary";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "text-word";
      } else if (["xml", "csv"].includes(item.extension)) {
        return "text-success";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "text-danger";
      } else {
        return "text-secondary";
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    ...mapGetters("general", ["getColorMode"]),
    user() {
      return this.$auth.user();
    },
  },
};
</script>
